import React from 'react';
import PropTypes from 'prop-types';
import './sub-head.scss';

const SubHead = ({ data, className }) => (<h3 className={className} dangerouslySetInnerHTML={{__html: data}} />);

SubHead.propTypes = {
  data: PropTypes.string,
  className: PropTypes.string,
};

export default SubHead;
